import styled from 'styled-components'
import { Button } from '@base'

export const ActionButton = styled(Button)`
	margin-left: auto;
`